import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

// 部分解除施設一覧参照API
import {
  IAPI_FAC021_Request,
  IAPI_FAC021_Response,
} from "../../../type/apiType";

// 申請状況更新API
import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// 部分解除施設一覧参照API
const httpIAPI_FAC021 = async (
  param: IAPI_FAC021_Request
): Promise<IAPI_FAC021_Response> => {
  const res = await http.post(ApiUrl.API_FAC021, { ...param });
  return res.data;
};

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpIAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpIAPI_FAC021, httpIAPI_APP016 };
